<div class="min-h-dvh bg-snow-white flex flex-col text-[13px] overflow-x-hidden">

  @if (loading()) {
    <div class="flex flex-col items-center justify-center gap-3 flex-1 py-16">
      <svg class="animate-spin h-6 w-6 text-action-blue" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
      </svg>
      <p class="text-[12px] text-steel-gray">Cargando disponibilidad…</p>
    </div>

  } @else if (error()) {
    <div class="flex flex-col items-center gap-3 flex-1 py-16 text-center px-6">
      <lucide-icon name="circle-alert" [size]="28" class="text-steel-gray" />
      <p class="text-[13px] text-slate-blue">{{ error() }}</p>
      <button type="button" (click)="retry()"
              class="text-[12px] font-semibold text-action-blue hover:underline">
        Reintentar
      </button>
    </div>

  } @else if (space()) {

    <div class="px-4 pt-4 pb-3 border-b border-pale-gray bg-snow-white shrink-0">
      <p class="text-[10px] font-bold uppercase tracking-[0.18em] text-action-blue mb-0.5">
        Disponibilidad
      </p>
      <h1 class="text-[15px] font-bold text-midnight-indigo leading-tight truncate">
        {{ space()!.name }}
      </h1>
      <p class="text-[11px] text-steel-gray mt-1">Pulsa un día libre para reservar</p>
    </div>

    <div class="flex flex-wrap items-center gap-x-4 gap-y-1 px-4 py-2
                bg-cloud-mist border-b border-pale-gray shrink-0">
      <span class="flex items-center gap-1.5 text-[10px] text-slate-blue">
        <span class="h-2.5 w-2.5 rounded bg-emerald-100 border border-emerald-300 shrink-0"></span>
        Libre
      </span>
      <span class="flex items-center gap-1.5 text-[10px] text-slate-blue">
        <span class="h-2.5 w-2.5 rounded bg-pale-gray border border-steel-gray shrink-0"></span>
        Parcial
      </span>
      <span class="flex items-center gap-1.5 text-[10px] text-slate-blue">
        <span class="h-2.5 w-2.5 rounded bg-red-100 border border-red-300 shrink-0"></span>
        Completo o cerrado
      </span>
    </div>

    <div class="flex-1 overflow-y-auto px-4 py-5">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-7">

        @for (month of months(); track month.label) {
          <div>
            <p class="text-[12px] font-bold text-midnight-indigo mb-2.5">{{ month.label }}</p>

            <div class="grid grid-cols-7 mb-0.5">
              @for (d of DOW; track d) {
                <div class="text-center text-[8px] font-bold uppercase tracking-widest
                            text-steel-gray py-1">{{ d }}</div>
              }
            </div>

            <div class="grid grid-cols-7 gap-0.5">
              @for (day of month.days; track (day.date || $index)) {

                @switch (day.status) {

                  @case ('padding') {
                    <div class="aspect-square"></div>
                  }

                  @case ('past') {
                    <div class="aspect-square flex items-center justify-center rounded-md
                                text-[10px] text-platinum-tint line-through select-none">
                      {{ day.dayNum }}
                    </div>
                  }

                  @case ('available') {
                    <button type="button" (click)="onDayClick(day)"
                      style="touch-action:manipulation"
                      class="aspect-square flex items-center justify-center rounded-md
                             text-[10px] font-semibold transition-all
                             bg-emerald-100 text-emerald-700 hover:bg-emerald-200
                             focus:outline-none focus:ring-2 focus:ring-emerald-400/50"
                      [class.ring-2]="day.isToday"
                      [class.ring-midnight-indigo]="day.isToday">
                      {{ day.dayNum }}
                    </button>
                  }

                  @case ('partial') {
                    <button type="button" (click)="onDayClick(day)"
                      style="touch-action:manipulation"
                      class="aspect-square flex items-center justify-center rounded-md
                             text-[10px] font-medium transition-all
                             bg-pale-gray text-slate-blue hover:bg-platinum-tint
                             focus:outline-none focus:ring-2 focus:ring-steel-gray/40"
                      [class.ring-2]="day.isToday"
                      [class.ring-midnight-indigo]="day.isToday">
                      {{ day.dayNum }}
                    </button>
                  }

                  @case ('full') {
                    <div class="aspect-square flex items-center justify-center rounded-md
                                text-[10px] font-medium text-red-300 bg-red-50
                                cursor-not-allowed select-none"
                      [class.ring-2]="day.isToday"
                      [class.ring-midnight-indigo]="day.isToday">
                      {{ day.dayNum }}
                    </div>
                  }

                }
              }
            </div>
          </div>
        }

      </div>
    </div>

    <div class="px-4 py-2.5 shrink-0 text-center">
      <a href="https://timeflexrent.com" target="_blank" rel="noopener noreferrer"
         class="text-[10px] text-steel-gray hover:text-slate-blue transition-colors">
        Disponibilidad en tiempo real por
        <span class="font-semibold text-midnight-indigo">TimeFlexRent</span>
      </a>
    </div>

  }
</div>
